import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Profession } from '../../models/profession.model';

@Component({
  selector: 'bwc-profession-card',
  templateUrl: './profession-card.component.html',
  styleUrls: ['./profession-card.component.scss'],
})
export class ProfessionCardComponent {
  @Input() profession: Profession;
  @Input() isLiked = false;
  @Output() liked = new EventEmitter<Profession>();

  onLike(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.liked.emit(this.profession);
  }
}
